// extracted by mini-css-extract-plugin
var _1 = "NvAmcZlYg5";
var _2 = "SquSK38CaR";
var _3 = "esxNvD55Xk";
var _4 = "YBTCbuYNQu";
var _5 = "UkDp7_zOXT";
var _6 = "dnr7dxdF_H";
export { _1 as "anonymousImage", _2 as "avatar", _3 as "customImage", _4 as "size_large", _5 as "size_medium", _6 as "size_normal" }
